import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { teacher } from '../model/teacher';

@Injectable({
  providedIn: 'root'
})
export class GiftsService {
  readonly APIUrl = "https://api.stnhd.com/api/"
  //readonly APIUrl = "https://localhost:44301/api/"
  constructor(private http: HttpClient) { }
  getAllGifts(): Observable<any> {
    return this.http.get<any[]>(this.APIUrl + "Gift/getAllGift");
  }
  createGift(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Gift/createGift", model);
  }
  editGift(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Gift/editGift", model);
  }
  delGift(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Gift/delGift", model);
  }
}
